var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloatingAssetLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 144,
    viewBox: "0 0 129 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.802 144L0.0742188 0V144H128.802Z",
    fill: "#EDEDED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5452 143.999L0.54541 42.5449V143.999H96.5452Z",
    fill: "#D9D8D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M82.9093 110.182L112.909 144H87.8185L69.8184 125.342L82.9093 110.182Z",
    fill: "#818CF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2727 49.6365L0 21.8184V49.6365L15.8183 63.8184L27.2727 49.6365Z",
    fill: "#26364D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.091 144.001L0 85.0918V144.001H55.091Z",
    fill: "#26364D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.818 99.8185L0 61.6367V134.182L33.818 99.8185Z",
    fill: "#818CF8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M51.2725 118.908L73.0905 143.999H26.7271L51.2725 118.908Z",
    fill: "#818CF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingAssetLeft);
export default __webpack_public_path__ + "static/media/floating-asset-left.5900c592216789eb88320f82bedcef91.svg";
export { ForwardRef as ReactComponent };